export default function PublishModal({ onCancel, onConfirm }) {
  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h3>Publicar tarifa</h3>

        <p>
          Una vez publicada, esta tarifa podrá ser utilizada por el
          taxímetro.
          <br />
          Cualquier cambio posterior debe realizarse mediante
          una nueva versión.
        </p>

        <div className="modal-actions">
          <button onClick={onCancel}>Cancelar</button>
          <button className="btn-primary" onClick={onConfirm}>
            ✅ Publicar tarifa
          </button>
        </div>
      </div>
    </div>
  );
}
